import clsx from 'clsx'

import s from '../styles.module.scss'

interface AirportInfoProps {
  time: string
  code: string
}

export const AirportInfo = ({ time, code }: AirportInfoProps) => (
  <div className={s.airportInfo}>
    <span className={clsx('medium-14', s.airportTime)}>{time}</span>
    <span className={clsx('medium-12', s.airportCode)}>{code}</span>
  </div>
)
